import Alpine from "alpinejs"
import collapsePlugin from '@alpinejs/collapse'
import resizePlugin from "@alpinejs/resize";
import focusPlugin from "@alpinejs/focus";

(window as any).Alpine = Alpine;

Alpine.plugin(collapsePlugin);
Alpine.plugin(resizePlugin);
Alpine.plugin(focusPlugin);

const globalStore = Alpine.reactive({
	mobileSearchActive: false,
	sidebarActive: false,

	toggleMobileSearch(active?: boolean) {
		if (window.innerWidth > 768) {
			return;
		}

		if (active === undefined) {
			active = !this.mobileSearchActive;
		}

		this.mobileSearchActive = active;
	},

	toggleSidebar(active?: boolean) {
		if (active === undefined) {
			active = !this.sidebarActive;
		}

		this.sidebarActive = active;
	}
})

Alpine.store('global', globalStore);

Alpine.data('mobileSearch', () => ({
		query: '',
		zipcode: null,
		isOpen: globalStore.mobileSearchActive,
		open: () => globalStore.mobileSearchActive = true,
		close: () => globalStore.mobileSearchActive = false,
		toggle: () => globalStore.mobileSearchActive = !globalStore.mobileSearchActive
}));

Alpine.start();
